import axios from 'axios';
import { Poppins, Quicksand } from 'next/font/google';
import React, { useState } from 'react'
const popins = Poppins({ weight: "400", subsets: ['latin'] });
const extrapopins = Poppins({ weight: "600", subsets: ['latin'] });
const quickSand = Quicksand({ weight: "400", subsets: ['latin'] });
export default function EnquiryForm() {
   const [loading,setLoading]=useState(false);
   const [formData, setFormData] = useState({
      name: "",
      email: "",
      mobileNumber: "",
      course: "",
      message: "" 
    });
     // Handle input changes
  const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData({ ...formData, [name]: value });
 }


 // Handle form submission
 const handleSubmit = async(e) => {
   e.preventDefault();
   setLoading(true);
   try {
       const response = await axios.post(`${process.env.db_url}/api/add-enquiries`,
        {name: formData.name,
         mobileNumber: formData.mobileNumber,
         email: formData.email,
         course: formData.course,
         message: formData.message,})
       // console.log("Form Data",response.data)
  
   // console.log("Form Data", formData);

   // Reset form
   setFormData({
     name: "",
     email: "",
     mobileNumber: "",
     course: "",
      message: ""
   });
 
 }
 catch (error) {
   console.error('Error Response:', error.response ? error.response.data : error.message);
   alert('Form Submission Is Failed,Please try again.');
 }
 finally{
   setLoading(false);
 }

 }

  return (
    <>
     <section className='mt28'>
        <div className=''>
        <h4 className={`fs-33 mfs-19 cb mtac ${extrapopins.className}`}>Write Us a <span className='ylw-clr'> Message </span></h4>
        <div className='mt20'>
            <form className='' onSubmit={handleSubmit}>
                <div className='df gap20 mfw mfjc'>
                    <input type='text' className={`input-box fs-22 pd10 ${popins.className}`} placeholder='Name'
                     name="name" value={formData.name} onChange={handleChange} required/>
                    <input type='tel' className={`input-box fs-22 pd10 ${popins.className}`} placeholder='Phone Number'
                     name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required/>
                </div>
                <div className='df gap20 mt12 mfw mfjc'>
                    <input type='email' className={`input-box fs-22 pd10 ${popins.className}`} placeholder='Email'
                     name="email" value={formData.email}onChange={handleChange} required/>
                    <input type='text' className={`input-box fs-22 pd10`} placeholder='Course'
                    name="course" value={formData.course} onChange={handleChange} required/>
                </div>
                <div className='df fdc mfjc mfac'>
                <textarea className={`textarea mt12 fs-22`} placeholder="Message"
                 name="message" value={formData.message} onChange={handleChange}/>
                <button className={`enquiry-btn cw pdtb10 cursor mt20 ${popins.className}`}>
  {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>) : "Submit" }

                </button>
                </div>
            </form>
        </div>
        </div>
     </section>
     <style jsx>
        {`
         /* Disabled state */
.btn:disabled {
  background-color: #B31942; /* Lighter background color when disabled */
  cursor: not-allowed; /* Change cursor to indicate disabled state */
  opacity: 0.6; /* Reduce opacity when disabled */
}

/* Spinner container */
.spinner-container {
  display: flex; /* Center spinner */
  align-items: center; /* Vertically center spinner */
  justify-content: center;
}

/* Spinner styles */
.spinner {
  border: 8px solid rgba(0, 0, 0, 0);
  border-left-color: #ffffff; /* Spinner color */
  border-radius: 50%;
  width: 20px; /* Spinner size */
  height: 20px; /* Spinner size */
  animation: spin 1s linear infinite;
}

/* Spinner animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
        .input-box{
           width: 100%;
           border-radius: 10px;
           border: 1px solid #000000;
        }
           .textarea{
           padding: 14px 0px 14px 6px;
           border-radius: 10px;
           width: 100%;
           }
           .enquiry-btn{
           background-color: #FFA900;
           border-radius: 10px;
           width: 315px;
           border: none;
           }
           @media only screen and (max-width: 833px){
            .input-box{
           width: 260px;
           border-radius: 10px;
           border: 1px solid #000000;
        }
           .textarea{
           padding: 14px 10px 14px 6px;
           border-radius: 10px;
           width: 260px;
           }
                .enquiry-btn{
           background-color: #FFA900;
           border-radius: 10px;
           width: 280px;
           border: none;
           }
           }
        `}
     </style>
    </>
  )
}
